import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

import {handle} from 'shared/utils';
import {ContentState} from 'shared/types';
import {StreamInput, SubmitState} from 'shared/interfaces';
import {ContentStatus} from 'shared/enums';

@Injectable()
export class AuthService {
  // @TODO
  readonly submitSubject: BehaviorSubject<
    StreamInput<SubmitState<any>>
  >;
  private readonly _submitState$: Observable<
    ContentState<SubmitState<any>>
  >;

  getSubmitState$(reset = false) {
    if (reset) {
      this.submitSubject.next({
        status: ContentStatus.INITIATED,
      });
    }
    return this._submitState$;
  }

  constructor() {
    // @TODO
    this.submitSubject = new BehaviorSubject<
      StreamInput<SubmitState<any>>
    >({
      status: ContentStatus.INITIATED,
    });
    // @TODO
    this._submitState$ = this.submitSubject.pipe(
      handle<SubmitState<any>>()
    );
  }
}
